// material
import {

    Card,
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableHead,
    TableContainer,
    Container,
} from '@material-ui/core';
// utils
import { RootState, useDispatch, useSelector } from 'redux/store';
import { useEffect } from 'react';
import { getSourceOfFunds } from 'redux/slices/sourceOfFunds';
import Page from 'components/Page';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import useLocales from 'hooks/useLocales';
// ----------------------------------------------------------------------

export default function SourceOfFunds() {
    const { translate } = useLocales();
    const dispatch = useDispatch();
    const { sourceOfFunds } = useSelector(
        (state: RootState) => state.sourceOfFunds
    );


    useEffect(() => {
        dispatch(getSourceOfFunds());
    }, [dispatch]);


    return (
        <>  <Page title="Source of funds">
            <Container maxWidth="xl">

                <HeaderBreadcrumbs
                    heading={translate(`dashboard.${"Source of funds"}`)}
                    links={[
                        // { name: 'Amount', href: PATH_DASHBOARD.user.root },
                        // { name: 'Delivery Options', href: PATH_DASHBOARD.user.root },
                    ]}
                />
                <Card sx={{ pb: 3 }}>
                    <TableContainer sx={{ minWidth: 720 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Source of funds Id</TableCell>
                                    <TableCell>Surce of funds code</TableCell>
                                    <TableCell>Surce of funds text</TableCell>
                                </TableRow>
                            </TableHead>
                            {sourceOfFunds !== null &&
                                <TableBody>
                                    {sourceOfFunds.map((row) => (
                                        <TableRow key={row.sourceOfFundsId}>
                                            <TableCell>{row.sourceOfFundsId}</TableCell>
                                            <TableCell>{row.sourceOfFundsCode}</TableCell>
                                            <TableCell>{row.sourceOfFundsText}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>}
                        </Table>

                    </TableContainer>
                </Card>
            </Container>
        </Page></>
    );
}